// extracted by mini-css-extract-plugin
export default {"content":"SearchFlags_content__VR1nM","input":"SearchFlags_input__13OKJ","button":"SearchFlags_button__oJ6lI"};